import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import AskPicsIcon from '../assets/askpics-icon.jpg';
import '../styles/PrivacyTOS.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="doc-page">
      <Helmet>
        <title>Privacy Policy — AskPics</title>
        <meta name="description" content="Read the AskPics privacy policy to understand how we handle your information and data." />
      </Helmet>

      <header className="doc-nav">
        <a href="/" className="doc-brand" aria-label="AskPics home">
          <span className="doc-brand__mark">
            <svg viewBox="2 5 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M21.2 22C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V10.8C22 10.52 22 10.38 21.9455 10.273C21.8976 10.1789 21.8211 10.1024 21.727 10.0545C21.62 10 21.48 10 21.2 10L18.8 10C18.52 10 18.38 10 18.273 10.0545C18.1789 10.1024 18.1024 10.1789 18.0545 10.273C18 10.38 18 10.52 18 10.8V13.2C18 13.48 18 13.62 17.9455 13.727C17.8976 13.8211 17.8211 13.8976 17.727 13.9455C17.62 14 17.48 14 17.2 14H14.8C14.52 14 14.38 14 14.273 14.0545C14.1789 14.1024 14.1024 14.1789 14.0545 14.273C14 14.38 14 14.52 14 14.8V17.2C14 17.48 14 17.62 13.9455 17.727C13.8976 17.8211 13.8211 17.8976 13.727 17.9455C13.62 18 13.48 18 13.2 18H10.8C10.52 18 10.38 18 10.273 18.0545C10.1789 18.1024 10.1024 18.1789 10.0545 18.273C10 18.38 10 18.52 10 18.8V21.2C10 21.48 10 21.62 10.0545 21.727C10.1024 21.8211 10.1789 21.8976 10.273 21.9455C10.38 22 10.52 22 10.8 22L21.2 22Z" fill="#fff"/>
              <path d="M10 6.8C10 6.52 10 6.38 10.0545 6.273C10.1024 6.179 10.1789 6.102 10.273 6.0545C10.38 6 10.52 6 10.8 6H13.2C13.48 6 13.62 6 13.727 6.0545C13.8211 6.102 13.8976 6.179 13.9455 6.273C14 6.38 14 6.52 14 6.8V9.2C14 9.48 14 9.62 13.9455 9.727C13.8976 9.821 13.8211 9.898 13.727 9.9455C13.62 10 13.48 10 13.2 10H10.8C10.52 10 10.38 10 10.273 9.9455C10.1789 9.898 10.1024 9.821 10.0545 9.727C10 9.62 10 9.48 10 9.2V6.8Z" fill="#fff"/>
              <path d="M3 12.8C3 12.52 3 12.38 3.0545 12.273C3.10243 12.179 3.17892 12.102 3.273 12.0545C3.37996 12 3.51997 12 3.8 12H6.2C6.48 12 6.62 12 6.727 12.0545C6.82108 12.102 6.89757 12.179 6.9455 12.273C7 12.38 7 12.52 7 12.8V15.2C7 15.48 7 15.62 6.9455 15.727C6.89757 15.821 6.82108 15.898 6.727 15.9455C6.62 16 6.48 16 6.2 16H3.8C3.51997 16 3.37996 16 3.273 15.9455C3.17892 15.898 3.10243 15.821 3.0545 15.727C3 15.62 3 15.48 3 15.2V12.8Z" fill="#fff"/>
            </svg>
          </span>
          <span className="doc-brand__word">AskPics</span>
          <img src={AskPicsIcon} alt="" className="doc-brand__icon" aria-hidden="true" />
        </a>
        <button className="doc-back" onClick={() => navigate('/')} aria-label="Back to home">
          <span className="doc-back__arrow">←</span>
          Back
        </button>
      </header>

      <div className="doc-header">
        <div className="doc-eyebrow">
          <span className="doc-eyebrow__box"></span>
          <span>Legal</span>
          <span className="doc-eyebrow__div"></span>
          <span>NOTICE · 002</span>
        </div>
        <h1 className="doc-title">Privacy Policy</h1>
      </div>

      <main className="doc-content">
        <section className="doc-section">
          <p>Welcome to our Privacy Policy. Your privacy is critically important to us. This policy explains how we handle your personal information and data.</p>
        </section>

        <section className="doc-section">
          <h2 className="doc-section__heading">Information We Collect</h2>
          <p>We collect information that you provide directly to us when you use our application. This includes information such as account details like your name, email address, and password, as well as data uploaded or created by you within the application.</p>
        </section>

        <section className="doc-section">
          <h2 className="doc-section__heading">How We Use Your Information</h2>
          <p>We use your information to provide and maintain our services, communicate with you about your account and our services, and improve our services and develop new features.</p>
        </section>

        <section className="doc-section">
          <h2 className="doc-section__heading">Protection of Your Information</h2>
          <p>We take reasonable measures to protect your information from unauthorized access, use, or disclosure.</p>
        </section>

        <section className="doc-section">
          <h2 className="doc-section__heading">Data Deletion</h2>
          <p>When you delete data in our application, it is permanently removed from our systems and cannot be recovered. We ensure that your deleted data is completely purged from our systems.</p>
        </section>

        <section className="doc-section">
          <h2 className="doc-section__heading">Information Sharing</h2>
          <p>We do not sell, trade, or otherwise transfer your personal information to third parties. We may share your information with trusted service providers who assist us in operating our application, provided that they agree to keep this information confidential.</p>
        </section>

        <section className="doc-section">
          <h2 className="doc-section__heading">Consent</h2>
          <p>By using our application, you consent to our Privacy Policy.</p>
        </section>

        <section className="doc-section">
          <h2 className="doc-section__heading">Policy Updates</h2>
          <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
        </section>

        <section className="doc-section">
          <h2 className="doc-section__heading">Contact Us</h2>
          <p>If you have any questions about our Privacy Policy, please contact us at: <a href="mailto:admin@ragobble.com">admin@ragobble.com</a></p>
        </section>
      </main>

      <footer className="doc-footer">
        <span>text + images + code © ragobble 2026 · all rights reserved</span>
        <div className="doc-footer__links">
          <a href="/support">Support</a>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
